/* Home de prueba · Decantopia */
(function () {
  if (window.HPHome) return;
  var HP = window.HPHome = {};
  var S = window.Shopify || {};
  var editor = !!S.designMode;
  var REV = '2026-07-15';
  var root = (S.routes && S.routes.root) || '/';

  function $$(sel, el) { return [].slice.call((el || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function t(s) { s = String(s || '').trim().replace(' ', 'T'); return Date.parse(s.length === 16 ? s + ':00-03:00' : s); }
  function money(cents) {
    var n = (cents || 0) / 100, f = window.hpMoneyFmt || '${{amount_no_decimals_with_comma_separator}}';
    function g(d, th, dp) { var p = n.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? dp + p[1] : ''); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (x, k) {
      return k === 'amount' ? g(2, ',', '.') : k === 'amount_no_decimals' ? g(0, ',', '.') : k === 'amount_with_comma_separator' ? g(2, '.', ',') :
        k === 'amount_with_space_separator' ? g(2, ' ', ',') : k === 'amount_with_period_and_space_separator' ? g(2, ' ', '.') :
        k === 'amount_no_decimals_with_space_separator' ? g(0, ' ', ',') : k === 'amount_with_apostrophe_separator' ? g(2, "'", '.') : g(0, '.', ',');
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Fases y contador (barra y franja de la Última Tanda) ---------- */
  function target(el) {
    var d = {}; try { d = JSON.parse(el.getAttribute('data-hp-fechas') || '{}'); } catch (e) {}
    var f = el.getAttribute('data-fase');
    return f === 'pre' ? t(d.vip) : f === 'vip' ? t(d.cyber) : f === 'cyber' ? t(d.end) : f === 'ext' ? t(d.ext) : NaN;
  }
  function tick() {
    $$('.hp[data-hp-fechas]').forEach(function (el) {
      if (window.hpFase) window.hpFase(el);
      var tg = target(el);
      var rem = isNaN(tg) ? 0 : Math.max(0, Math.floor((tg - Date.now()) / 1000));
      var v = { d: pad(Math.floor(rem / 86400)), h: pad(Math.floor(rem % 86400 / 3600)), m: pad(Math.floor(rem % 3600 / 60)), s: pad(rem % 60) };
      $$('[data-hp-cd] [data-u]', el).forEach(function (b) { var u = b.getAttribute('data-u'); if (b.textContent !== v[u]) b.textContent = v[u]; });
    });
  }

  /* ---------- Tarjetas: tamaño y agregar al carro ---------- */
  function bindCard(card) {
    if (card.getAttribute('data-bound')) return;
    card.setAttribute('data-bound', '1');
    var add = card.querySelector('[data-hp-add]');
    var price = card.querySelector('[data-hp-price]');
    var msg = card.querySelector('[data-hp-msg]');
    $$('.hp-chip', card).forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.disabled) return;
        $$('.hp-chip', card).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        if (add) add.setAttribute('data-v', chip.getAttribute('data-v'));
        if (msg) msg.textContent = '';
      });
    });
    if (!add) return;
    add.addEventListener('click', function () {
      var id = Number(add.getAttribute('data-v'));
      if (!id) return;
      var label = add.textContent;
      add.disabled = true; add.textContent = 'Agregando…'; if (msg) msg.textContent = '';
      var ids = $$('cart-items-component').map(function (c) { return c.getAttribute('data-section-id'); }).filter(Boolean);
      var body = { items: [{ id: id, quantity: 1 }] };
      if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar'); return j; }); })
        .then(function (res) {
          add.textContent = 'Agregado ✓';
          if (msg) msg.innerHTML = '¡Listo! <a href="' + root + 'cart">Ver carro</a>';
          return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            var detail = { resource: cart, sourceId: 'hp-home', data: { source: 'hp-home', itemCount: cart.item_count, productId: res && res.items && res.items[0] && String(res.items[0].product_id), sections: res && res.sections } };
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart }));
            $$('.cart-count, [data-cart-count], .cart-bubble__text-count').forEach(function (n) { n.textContent = cart.item_count; });
          }).catch(function () {});
        })
        .catch(function (e) {
          if (msg) msg.textContent = e && e.message ? e.message : 'No pudimos agregarlo. Inténtalo de nuevo.';
        })
        .then(function () { setTimeout(function () { add.disabled = false; add.textContent = label; }, 1600); });
    });
  }

  /* ---------- Vistos por ti ---------- */
  function vistos() {
    try { return JSON.parse(localStorage.getItem('dc_rv') || '[]') || []; } catch (e) { return []; }
  }
  function cardHTML(p, agregar) {
    var first = null, min = null;
    (p.variants || []).forEach(function (v) { if (v.available) { if (!first) first = v; if (min === null || v.price < min) min = v.price; } });
    if (min === null) min = p.price_min || p.price;
    var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
    var sep = img.indexOf('?') > -1 ? '&' : '?';
    var title = String(p.title || '').replace(/^DECANT\s+-\s+/, '').replace(/^DECANT\s+/, '');
    var url = root + 'products/' + p.handle;
    var chips = '';
    if ((p.variants || []).length > 1) {
      chips = '<div class="hp-chips" role="group" aria-label="Tamaño y precio">' + p.variants.map(function (v) {
        return '<button type="button" class="hp-chip" data-v="' + v.id + '" aria-pressed="' + (first && v.id === first.id ? 'true' : 'false') + '"' + (v.available ? '' : ' disabled') + '><b>' + esc(String(v.title).replace(/\s*ml$/i, ' ml')) + '</b><span>' + esc(money(v.price)) + '</span></button>';
      }).join('') + '</div>';
    }
    var btn = first ? '<button type="button" class="hp-btn hp-btn--dark hp-btn--sm hp-card__add" data-hp-add data-v="' + first.id + '">' + esc(agregar) + '</button>'
      : '<a class="hp-btn hp-btn--ghost hp-btn--sm hp-card__add" href="' + url + '">Ver producto</a>';
    return '<div class="hp-card" data-hp-card data-handle="' + esc(p.handle) + '">' +
      '<a class="hp-card__img" href="' + url + '" tabindex="-1" aria-hidden="true">' + (img ? '<img loading="lazy" alt="' + esc(p.title) + '" src="' + esc(img + sep + 'width=600') + '" srcset="' + esc(img + sep + 'width=300') + ' 300w, ' + esc(img + sep + 'width=600') + ' 600w" sizes="(min-width: 990px) 290px, 64vw">' : '') + '</a>' +
      '<div class="hp-card__body"><a class="hp-card__t" href="' + url + '">' + esc(title) + '</a>' +
      (chips || '<div class="hp-card__p" data-hp-price>' + money(min) + '</div>') + btn +
      '<p class="hp-card__msg" data-hp-msg aria-live="polite"></p></div></div>';
  }
  function initVendidos(sec) {
    if (sec.getAttribute('data-bound')) return;
    sec.setAttribute('data-bound', '1');
    $$('[data-hp-card]', sec).forEach(bindCard);
    if (sec.getAttribute('data-vistos') !== 'true') return;
    var max = Number(sec.getAttribute('data-max')) || 8;
    var minV = Number(sec.getAttribute('data-min-vistos')) || 2;
    var skip = String(sec.getAttribute('data-ocultar') || '').toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var list = vistos().filter(function (h) { return skip.indexOf(String(h).toLowerCase()) < 0; }).slice(0, max);
    if (editor && !list.length) return;
    if (list.length < minV) return;
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(function (p) { return p && p.available; });
      if (ps.length < minV) return;
      var panelR = sec.querySelector('[data-hp-panel="r"]'), panelV = sec.querySelector('[data-hp-panel="v"]');
      var tabs = sec.querySelector('.hp-tabs'), tR = sec.querySelector('[data-hp-t-r]'), tV = sec.querySelector('[data-hp-t-v]'), eb = sec.querySelector('[data-hp-eb-v]');
      var agregar = sec.getAttribute('data-agregar') || 'Agregar al carro';
      panelR.innerHTML = ps.map(function (p) { return cardHTML(p, agregar); }).join('');
      $$('[data-hp-card]', panelR).forEach(bindCard);
      function show(which) {
        var r = which === 'r';
        panelR.hidden = !r; panelV.hidden = r;
        if (tR) tR.hidden = !r; if (tV) tV.hidden = r; if (eb) eb.hidden = r;
        $$('[data-hp-tab]', tabs).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-hp-tab') === which ? 'true' : 'false'); });
        if (sec.hpUpd) sec.hpUpd();
      }
      $$('[data-hp-tab]', tabs).forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-hp-tab')); }); });
      tabs.hidden = false;
      show('r');
      if (sec.hpUpd) sec.hpUpd();
    });
  }

  /* ---------- Carrusel de reseñas ---------- */
  function initSlider(sl) {
    if (sl.getAttribute('data-sbound')) return;
    sl.setAttribute('data-sbound', '1');
    var prev = sl.querySelector('[data-hp-prev]'), next = sl.querySelector('[data-hp-next]');
    function track() { return sl.querySelector('[data-hp-track]:not([hidden])'); }
    function gap(tr) { var g = parseFloat(getComputedStyle(tr).columnGap || getComputedStyle(tr).gap); return isNaN(g) ? 16 : g; }
    function step() { var tr = track(); if (!tr) return 0; var c = tr.firstElementChild; return c ? c.getBoundingClientRect().width + gap(tr) : tr.clientWidth; }
    function upd() {
      var tr = track(); if (!tr) return;
      var max = tr.scrollWidth - tr.clientWidth - 2;
      if (prev) prev.disabled = tr.scrollLeft <= 2;
      if (next) next.disabled = tr.scrollLeft >= max;
      var arrows = prev && prev.parentNode; if (arrows) arrows.style.visibility = max <= 0 ? 'hidden' : '';
    }
    if (prev) prev.addEventListener('click', function () { var tr = track(); if (tr) tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { var tr = track(); if (tr) tr.scrollBy({ left: step(), behavior: 'smooth' }); });
    $$('[data-hp-track]', sl).forEach(function (tr) { tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true }); });
    window.addEventListener('resize', upd);
    sl.hpUpd = upd;
    upd();
  }

  /* ---------- Suscripción (Klaviyo, API pública) ---------- */
  function kPost(key, path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': REV }, body: JSON.stringify(body)
    }).then(function (r) { if (r.status < 200 || r.status >= 300) { var e = new Error('klaviyo ' + r.status); e.status = r.status; throw e; } return r; });
  }
  function subscribe(key, list, email, source, props) {
    var full = { data: { type: 'subscription', attributes: { custom_source: source || 'Home', profile: { data: { type: 'profile', attributes: { email: email, properties: props || { hp_origen: 'home' } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
    var min = { data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
    return kPost(key, 'subscriptions', full).catch(function (e) { if (e.status === 400) return kPost(key, 'subscriptions', min); throw e; });
  }
  function initForm(f) {
    if (f.getAttribute('data-bound')) return;
    f.setAttribute('data-bound', '1');
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var box = f.parentNode, msg = box.querySelector('[data-hp-msg]'), inp = f.querySelector('input[type=email]'), trap = f.querySelector('input[name=web]'), btn = f.querySelector('button[type=submit]');
      if (trap && trap.value) return;
      var email = (inp.value || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg.textContent = 'Revisa tu correo: parece que falta algo.'; inp.focus(); return; }
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'Enviando…'; msg.textContent = '';
      var job = editor ? new Promise(function (res) { setTimeout(res, 500); }) : subscribe(f.getAttribute('data-key'), f.getAttribute('data-list'), email, f.getAttribute('data-source'));
      job.then(function () {
        msg.textContent = editor ? 'En el editor no se inscribe a nadie. En la tienda aquí aparece: ' + (f.getAttribute('data-ok') || '¡Listo!') : (f.getAttribute('data-ok') || '¡Listo!');
        btn.textContent = editor ? label : '¡Listo!';
        if (editor) btn.disabled = false; else inp.value = '';
      }).catch(function () {
        btn.disabled = false; btn.textContent = label;
        msg.textContent = f.getAttribute('data-err') || 'No pudimos inscribirte. Inténtalo de nuevo.';
      });
    });
  }

  /* ---------- Inscripción VIP en la franja Última Tanda (misma lista y datos que la landing) ---------- */
  function store(k, v, session) {
    try { var st = session ? window.sessionStorage : window.localStorage; if (v === undefined) return st.getItem(k); st.setItem(k, v); } catch (e) { return null; }
  }
  function utmData() {
    var u = {};
    try {
      var q = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { var v = q.get(k); if (v) u[k] = v.slice(0, 80); });
      if (Object.keys(u).length) store('ut_utm', JSON.stringify(u), true);
      else u = JSON.parse(store('ut_utm', undefined, true) || '{}') || {};
    } catch (e) { u = {}; }
    return u;
  }
  function initVip(f) {
    if (f.getAttribute('data-bound')) return;
    f.setAttribute('data-bound', '1');
    utmData();
    var box = f.closest('[data-hp-vip-box]') || f.parentNode, sec = f.closest('[data-fase]');
    var msg = box.querySelector('[data-hp-msg]'), ir = box.querySelector('[data-hp-vip-ir]');
    var inp = f.querySelector('input[type=email]'), trap = f.querySelector('input[name=web]'), btn = f.querySelector('button[type=submit]');
    function fase() { return (sec && sec.getAttribute('data-fase')) || 'pre'; }
    function listo(texto) { box.classList.add('is-ok'); if (msg) msg.textContent = texto || '¡Listo!'; }
    if (!editor && store('ut_vip') === '1') {
      if (fase() === 'vip' && ir) { f.hidden = true; ir.hidden = false; }
      else if (fase() === 'pre') listo(f.getAttribute('data-ya'));
    }
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (trap && trap.value) return;
      var email = (inp.value || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { if (msg) msg.textContent = 'Revisa tu correo: parece que falta algo.'; inp.focus(); return; }
      var ph = fase(), u = utmData();
      var props = { ut_origen: u.utm_source || 'home', ut_campana: u.utm_campaign || '', ut_concepto: u.utm_content || '', ut_fase: ph };
      var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Inscribiendo…'; if (msg) msg.textContent = '';
      var job = editor ? new Promise(function (res) { setTimeout(res, 500); }) : subscribe(f.getAttribute('data-key'), f.getAttribute('data-list'), email, f.getAttribute('data-source') || 'Home La Ultima Tanda', props);
      job.then(function () {
        if (editor) {
          btn.disabled = false; btn.innerHTML = label;
          if (msg) msg.textContent = 'En el editor no se inscribe a nadie. En la tienda aquí aparece: ' + (f.getAttribute('data-ok') || '¡Listo!');
          return;
        }
        store('ut_vip', '1'); store('ut_email', email, true);
        if (ph === 'vip') { location.href = f.getAttribute('data-landing') || '/pages/ultima-tanda?vip=1'; return; }
        var g = f.getAttribute('data-gracias');
        if (g) { location.href = g; return; }
        listo(f.getAttribute('data-ok'));
      }).catch(function () {
        btn.disabled = false; btn.innerHTML = label;
        if (msg) msg.innerHTML = f.getAttribute('data-err') || 'No pudimos inscribirte. Inténtalo de nuevo.';
      });
    });
  }

  function init() {
    $$('[data-hp-slider]').forEach(initSlider);
    $$('[data-hp-vendidos]').forEach(initVendidos);
    $$('.hp [data-hp-card]').forEach(bindCard);
    $$('form[data-hp-form]').forEach(initForm);
    $$('form[data-hp-vip]').forEach(initVip);
    tick();
    if (!HP.timer) HP.timer = setInterval(tick, 1000);
  }
  HP.init = init;
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();